function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { guid } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { Time } from '../../common/icons';
import { SelectInput } from '../select/components/SelectInput';
import { RcPopover } from '../../units/popover-wrapper';
export function TimePopper(props) {
  var show = props.show,
      size = props.size,
      width = props.width,
      onShow = props.onShow,
      onHide = props.onHide,
      onClear = props.onClear,
      children = props.children,
      placeholder = props.placeholder,
      renderTrigger = props.renderTrigger,
      _props$datasource = props.datasource,
      datasource = _props$datasource === void 0 ? [] : _props$datasource,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? true : _props$clearable,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      extra = _objectWithoutProperties(props, ["show", "size", "width", "onShow", "onHide", "onClear", "children", "placeholder", "renderTrigger", "datasource", "disabled", "clearable", "placement"]);

  var handleShow = useRefCallback(onShow);
  var handleHide = useRefCallback(onHide);
  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var onClearCallback = useRefCallback(onClear);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var handleClear = useCallback(function (val) {
    if (!val) {
      onClearCallback();
    }
  }, []);
  var placeholderInputCls = usePrefixCls('time-picker-input-placeholder');
  return React.createElement(React.Fragment, null, React.createElement(SelectInput, Object.assign({}, extra, {
    size: size,
    width: width,
    suffix: React.createElement(Time, null),
    disabled: disabled,
    triggerId: triggerId,
    placeholder: placeholder,
    onValueChange: handleClear,
    className: placeholderInputCls,
    clearable: !disabled && clearable,
    value: datasource.length ? datasource[0].label : ''
  }), renderTrigger ? renderTrigger(false) : null), React.createElement(RcPopover, {
    lazyInit: true,
    hideToDestroy: true,
    show: show,
    arrow: false,
    onShow: handleShow,
    onHide: handleHide,
    placement: placement,
    offset: {
      x: 0,
      y: 4
    },
    triggerIds: triggerIds,
    getPopper: function getPopper() {
      return children;
    },
    scaleAnimation: "y"
  }));
}